export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  // These options can be used to round to whole numbers.
  trailingZeroDisplay: 'stripIfInteger',
  maximumFractionDigits: 0,
});

export const ratioFormatter = new Intl.NumberFormat('en-US', {
  style: 'decimal',
  // These options can be used to round to whole numbers.
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});
